module.exports = __webpack_public_path__ + "static/media/dynamite.c197cca4.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/dynamite.gif
// module id = 822
// module chunks = 0